var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 590,
    viewBox: "0 0 360 590",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gforest",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#134e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#71b280"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 590,
    fill: "url(#gforest)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(0,0,0,0.2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "60,590 80,450 40,450"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120,590 145,400 95,400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200,590 230,420 170,420"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280,590 305,460 255,460"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340,590 355,480 325,480"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForest);
export default __webpack_public_path__ + "static/media/forest.009216dbec4f78fddc4167f30f4fc518.svg";
export { ForwardRef as ReactComponent };